const AuthenticatedMenuItems = [
  { title: "Events", link: "/app/events" },
  { title: "Contact Us", link: "/app/contactus" },
  { title: "Abstracts", link: "/app/abstracts" },
  { title: "Gallery", link: "/app/gallery" },
  { title: "Volunteers", link: "/app/volunteers" },
  { title: "Subscribers", link: "/app/subscribers" },
  { title: "Speakers", link: "/app/speakers" },
];

export default AuthenticatedMenuItems;
